import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

const hasOverflow = (el) => el.clientHeight < el.scrollHeight;
const isScrolledDown = (el, threshold) => {
  const bottom = el.scrollTop + el.clientHeight;
  return bottom >= el.scrollHeight - threshold;
};
const isScrolledUp = (el) => el.scrollTop === 0;
const scrollDown = (el) => {
  setTimeout(() => (el.scrollTop = el.scrollHeight - el.clientHeight), 0);
};
const scrollDownBy = (amount, el) => (el.scrollTop += amount);
const ScrollContainner = (
  Component,
  { isScrolledDownThreshold = 150 } = {}
) => {
  class ScroolInner extends React.PureComponent {
    constructor(props) {
      super(props);
      this.isScrolledDown = true;
      this.scrollContainner = null;
      this.scrollHeight = null;
      this.isScrolledUp = null;
      this.lastMessageId = null;
      this.resizeObserver = null;
      this.prevHeight = null
    }

    scrollDownIfNeeded() {
      if (this.isScrolledDown && hasOverflow(this.scrollContainner)) {
        scrollDown(this.scrollContainner);
      }
    }

    handleScroll(event) {
      const lastId = this.props?.chatmessages?.id;
      const hasMore = this.props?.chatmessages?.hasMore
      const { target } = event;
      this.isScrolledDown = isScrolledDown(
        this.scrollContainner,
        isScrolledDownThreshold
      );
      if (isScrolledUp(this.scrollContainner)) {
        this.scrollHeight = this.scrollContainner.scrollHeight;
        setTimeout(
          () => this.props.onScrolledTop && this.props.onScrolledTop(event),
          0
        );
      }
      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        if (!hasMore || (this.lastMessageId && this.lastMessageId === lastId)) {
          return;
        }
        this.lastMessageId = lastId;
        setTimeout(
          () =>
            this.props.onScrolledBottom && this.props.onScrolledBottom(event),
          0
        );
        return;
      }
    }

    updateHeigth = () => {
      const container = document.querySelector('.report_conver_wrp');
      if (!container) return;
      container.style.height = container.clientHeight + 'px';
      container.style[ 'overflow-y' ] = 'auto';
      container.style[ 'overflow-x' ] = 'hidden';
      this.scrollDownIfNeeded();
    };

    componentDidMount() {
      this.updateHeigth() 
      this.scrollDownIfNeeded();
    }

    componentDidUpdate(prevProps) {
      this.isScrolledUp = isScrolledUp(this.scrollContainner);
      if (this.isScrolledUp && this.scrollHeight !== null) {
        const difference =
          this.scrollContainner.scrollHeight - this.scrollHeight;
        this.scrollHeight = null;
        scrollDownBy(difference, this.scrollContainner);
      } else {
        this.scrollDownIfNeeded();
      }
    }
    render() {
      const { containerId = 'message-containner', chatmessages } = this.props;
      if(!chatmessages) {
        return
      }
      return (
        <Fragment>
          <div
            onScroll={ (e) => this.handleScroll(e) }
            ref={ (el) => (this.scrollContainner = ReactDOM.findDOMNode(el)) }
            id={ containerId }
            className={ containerId }
          >
            <div className='extraSpace'></div>
            <div id='message-parent-wrapper'>
              <Component { ...this.props } />
            </div>
          </div>
        </Fragment>
      );
    }
  }
  return connect(null, null)(ScroolInner);
};

export default ScrollContainner;